// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 8702
// module chunks = 0